import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Carousel,
  CarouselIndicators,
  CarouselControl,
  CarouselItem,
  CarouselCaption
} from 'reactstrap';

export default class CarouselCustom extends Component {
  static propTypes = {
    items: PropTypes.array,
  };

  state = {
    activeIndex: 0,
    animating: false
  };

  onExiting = () => {
    this.animating = true;
  };

  onExited = () => {
    this.animating = false;
  };

  next = () => {
    const { items } = this.props;
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({activeIndex: nextIndex});
  };

  previous = () => {
    const { items } = this.props;
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({activeIndex: nextIndex});
  };

  goToIndex = (newIndex) => {
    if (this.animating) return;
    this.setState({activeIndex: newIndex});
  };

  renderSlide = (items) => {
    return items.map((item, index) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src+index}
        >
          <img className="d-block w-100" src={item.src}/>
          <CarouselCaption captionText={item.caption}/>
        </CarouselItem>
      );
    });
  };

  render() {
    const { activeIndex } = this.state;
    const { items } = this.props;
    return items.length === 0 ? null : (
      <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous}>
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex}/>
        {this.renderSlide(items)}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous}/>
        <CarouselControl direction="next" directionText="Next" onClickHandler={this.next}/>
      </Carousel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/custom/Carousel.js